module.exports = __webpack_public_path__ + "img/star_03.2827f828.png";